// extracted by mini-css-extract-plugin
export default {"candidatesList":"candidatesList__yPn5j","buttonWrapper":"buttonWrapper__zT7Nr","buttonList":"buttonList__VzCC6"};